var _rect, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrezor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trezor",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "auto",
    height: "auto",
    fill: "#FFFFFF",
    viewBox: "0 0 685.984 210",
    enableBackground: "new 0 0 685.984 210",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rect25",
    x: 320.944,
    y: 717.998,
    display: "none",
    fill: "#FFFFFF",
    stroke: "#000000",
    width: 11,
    height: 35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "M97.879,19.707c-23.563,0-42.667,19.103-42.667,42.667v15.953 c-8.269,1.479-16.614,3.522-16.614,6.133v83.586c0,0,0,2.344,2.553,3.359c9.427,3.751,46.438,16.869,54.932,19.873 c1.119,0.396,1.355,0.385,1.743,0.385c0.408,0,0.619,0.014,1.729-0.379c8.478-2.997,45.617-16.148,54.985-19.857 c2.433-0.963,2.503-3.347,2.503-3.347V84.464c0-2.61-8.229-4.658-16.499-6.138V62.373C140.545,38.81,121.442,19.707,97.879,19.707z  M97.879,40.098c13.86,0,22.292,8.416,22.292,22.276v13.898c-15.649-1.14-28.947-1.14-44.598,0V62.374 C75.573,48.513,84.017,40.098,97.879,40.098z M97.824,96.79c19.389,0.031,35.688,1.475,35.688,4.235c0,0,0,51.321,0,52.08 c0,0.76-0.12,0.888-0.841,1.161c-0.72,0.274-33.149,11.993-33.149,11.993s-1.331,0.442-1.697,0.442c-0.415,0-1.747-0.46-1.747-0.46 s-32.415-11.708-33.143-11.983c-0.729-0.274-0.823-0.416-0.823-1.182c0-0.844,0-52.053,0-52.053 C62.112,98.188,78.436,96.759,97.824,96.79z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g3222",
    transform: "matrix(0.95575135,0,0,0.95575135,91.363135,-287.43374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "M126.229,461.703v-59.704h-21.763v-21.4h67.972v21.4h-21.646v59.704H126.229z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "M227.522,461.703l-11.185-25.534h-8.877v25.534h-24.561v-81.104h43.286 c18.967,0,29.184,12.645,29.184,27.844c0,13.987-8.148,21.401-14.591,24.563l14.714,28.696h-27.969V461.703z M230.44,408.32 c0-4.375-3.891-6.323-8.026-6.323h-14.957v12.767h14.957C226.549,414.763,230.44,412.822,230.44,408.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "M268.232,461.703v-81.104h61.527v21.4h-36.965v8.026h36.115v21.403h-36.115 v8.873h36.965v21.402H268.232z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    d: "M342.547,461.718v-19.454l30.883-40.249h-30.883v-21.4h63.349v19.333l-31.007,40.37h31.857v21.4h-64.199V461.718z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "M412.762,421.229c0-24.929,19.331-41.952,44.381-41.952c25.046,0,44.383,17.023,44.383,41.952c0,24.925-19.337,41.948-44.383,41.948C432.093,463.177,412.762,446.154,412.762,421.229z  M476.599,421.229c0-11.311-7.66-20.308-19.456-20.308c-11.794,0-19.457,8.998-19.457,20.308c0,11.307,7.661,20.303,19.457,20.303 C468.937,441.532,476.599,432.534,476.599,421.229z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    d: "M556.611,461.718l-11.182-25.534h-8.879v25.534h-24.563v-81.103h43.289 c18.971,0,29.185,12.645,29.185,27.843c0,13.987-8.149,21.401-14.594,24.565l14.713,28.696H556.611z M559.531,408.336 c0-4.376-3.89-6.323-8.026-6.323h-14.957v12.767h14.957C555.638,414.781,559.531,412.838,559.531,408.336z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrezor);
export default __webpack_public_path__ + "static/media/trezor.00f3c3bacd5bb090f3b83e5eb1323090.svg";
export { ForwardRef as ReactComponent };